module.exports = {"title":"All information"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/en/print.json
// module id = kfF0
// module chunks = 1